// extracted by mini-css-extract-plugin
module.exports = {"root":"_844589","heading":"_0d6753","info":"_e0ae93","clickoutIcon":"_381a24","title":"_ffb339","logoContainer":"_13e17b","logo":"_b618f1","ctaWrapper":"_c6527e","cta":"_b0ec5c"};